import { courseBffApiBaseUrl } from '@/utils/endpoints';

const isMockApi = () => {
  return courseBffApiBaseUrl.includes('course-bff.mock');
};

export const initializeMock = async () => {
  if (!import.meta.env.DEV || !isMockApi()) return;

  const { setupWorker } = await import('msw/browser');
  const handlers = await import('@/mocks/handlers');
  const worker = setupWorker(...handlers.default);

  return worker.start({
    serviceWorker: {
      url: '/mockServiceWorker.js?worker',
    },
  });
};
